import * as ScrollMagic from 'scrollmagic'
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap'
import {gsap} from 'gsap'

export default function() {
	var controller = new ScrollMagic.Controller();

	var slideParallaxScene = new ScrollMagic.Scene({
		triggerElement: '.top_bg .contents',
		triggerHook: 1,
		duration: '180%'
	})
	.setTween(TweenMax.from('.bg_cover', 1, {y: '-30%', ease:Power0.easeNone}))
	.addTo(controller);
}
